import {
  COLUMN_WIDTHS,
  DEFAULT_NUMBER_COLUMN_WIDTH,
  DEFAULT_TEXT_COLUMN_WIDTH,
  TEXT_COLUMNS,
} from '../components/materials/materialPresentationConstants';

/**
 * Ancho fijo de una columna de reporte de materiales, para que filtrar u ordenar no mueva la tabla.
 * @param {string} key Clave de la columna.
 * @returns {number} Ancho en píxeles.
 */
export const getMaterialColumnWidth = (key) =>
  COLUMN_WIDTHS[key] ||
  (TEXT_COLUMNS.includes(key) ? DEFAULT_TEXT_COLUMN_WIDTH : DEFAULT_NUMBER_COLUMN_WIDTH);
